import { gql } from '@apollo/client'

export const TOGGLE_OVERWRITE_HIPAA = gql`
  mutation ToggleOverwriteHIPAA($groupId: ID!) {
    toggleOverwriteAcceptHipaa(groupId: $groupId)
  }
`
